import { i18n } from '@pinnacleautomotive/clarity-components';
import approvalsEn from './en/approvals.json';
import bulkEn from './en/bulk.json';
import globalEn from './en/global.json';
import ordersEn from './en/orders.json';
import reportsEn from './en/reports.json';
import usersEn from './en/users.json';
import approvalsEs from './es/approvals.json';
import bulkEs from './es/bulk.json';
import globalEs from './es/global.json';
import ordersEs from './es/orders.json';
import usersEs from './es/users.json';

i18n.addResourceBundle('en', 'global', globalEn, true, false);
i18n.addResourceBundle('es', 'global', globalEs, true, false);

i18n.addResourceBundle('en', 'orders', ordersEn, true, false);
i18n.addResourceBundle('es', 'orders', ordersEs, true, false);

i18n.addResourceBundle('en', 'bulk', bulkEn, true, false);
i18n.addResourceBundle('es', 'bulk', bulkEs, true, false);

i18n.addResourceBundle('en', 'users', usersEn, true, false);
i18n.addResourceBundle('es', 'users', usersEs, true, false);

i18n.addResourceBundle('en', 'approvals', approvalsEn, true, false);
i18n.addResourceBundle('es', 'approvals', approvalsEs, true, false);

i18n.addResourceBundle('en', 'reports', reportsEn, true, false);

export default i18n;
